import { XYBubbleMetadata } from '@/components/public/Visualisations/XYBubbles/Metadata/XYBubbleMetadata'

export class XYBubblesMetadataRegister {
  private _bubbles: Record<string, XYBubbleMetadata> = {}

  reset() {
    this._bubbles = {}
  }

  addBubble(bubble: XYBubbleMetadata) {
    this._bubbles[bubble.key] = bubble
  }

  removeBubble(key: string) {
    delete this._bubbles[key]
  }

  getBubble(key: string): XYBubbleMetadata {
    return this._bubbles[key]
  }

  get bubbles(): XYBubbleMetadata[] {
    return Object.values(this._bubbles)
  }
}
